import { FONT_FAMILIES } from '@/constant';
import { SlideComponentText } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentTextCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentText {
        return {
            id: id,
            type: 'text',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 200, height: 50 },
            content: {
                text: '',
                fontSize: 16,
                jyutping: [],
                color: '#000000',
                typeSettings: {
                    fontFamily: FONT_FAMILIES[0]?.fontFamily || 'Noto Sans SC',
                    formatting: [],
                    alignment: 'center',
                    isPhonetic: false,
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                },
            },
        };
    }
}
